import React from "react";
import { useRoutePath } from "../../../../../util/Routing";
import { EntityDetailPage } from "../shared/EntityDetailPage";

export function SupplierDetailPage(): JSX.Element {
  const { adminPath } = useRoutePath();
  return (
    <EntityDetailPage
      entityType="supplier"
      listPath={`${adminPath}/mdm/suppliers`}
    />
  );
}
